import React from 'react';
import styles from '../styles/PolicyDetailsContainer.module.scss';
import PolicyItemStatus from 'components/policy-list/PolicyListItemStatus';
import { ActiveStatus, ErrorStatus } from 'components/status';
import { PolicyStatus } from 'constants/policy';
import { dateLessThanOrEqualToDays, getPolicyStatus } from 'helpers';
import { FREQUENCY } from 'constants/options';
import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';

const getExpiredStatus = (policy) => {
  return policy.policyType === INSURANCE_TYPES_NAMES.MBI
    ? 'Expired'
    : 'Expired - renew now';
};

const getStatus = (policy, status) => {
  switch (status) {
    case PolicyStatus.EXPIRED: {
      const text = dateLessThanOrEqualToDays(0, policy.renewalDate)
        ? getExpiredStatus(policy)
        : 'Expiring soon';
      return <ErrorStatus text={text} />;
    }
    case PolicyStatus.RENEWING:
      return <ActiveStatus text="Active - renewed" />;
    default:
      return <PolicyItemStatus policy={policy} hideTooltips={true} />;
  }
};

const PolicyDetailsStatus = ({ policy, onClick }) => {
  const status = getPolicyStatus(policy);
  const enablePillClick =
    status === PolicyStatus.EXPIRED && policy.frequency !== FREQUENCY.ONE_OFF;
  return (
    <div
      className={classnames(
        styles.status,
        enablePillClick && styles.enableClick,
      )}
      onClick={onClick}
    >
      {getStatus(policy, status)}
    </div>
  );
};

export default PolicyDetailsStatus;
